import { render, staticRenderFns } from "./MailChimp.vue?vue&type=template&id=4ad71c87&"
import script from "./MailChimp.vue?vue&type=script&lang=js&"
export * from "./MailChimp.vue?vue&type=script&lang=js&"
import style0 from "./MailChimp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports